import { render, staticRenderFns } from "./auction-item.vue?vue&type=template&id=a068d55c&scoped=true&"
import script from "./auction-item.vue?vue&type=script&lang=js&"
export * from "./auction-item.vue?vue&type=script&lang=js&"
import style0 from "./auction-item.vue?vue&type=style&index=0&id=a068d55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068d55c",
  null
  
)

export default component.exports